"use strict";

import $ from "jquery";
/**
 * Simply toggles parameter show/hide
 * @return {[undefined]}       [nothing returned]
 */

export default function toggler() {
    /* accordion data-parameters
     * @param  {[number]} speed    [speed in ms]
     * @param  {[string]} object    [selector of toggled element]
     * @param  {[animation]} object    [toggling animation]
     */
    const TOGGLER = ".js-toggler";
    const ANIMATIONS = {
        fade: $.fn.fadeToggle,
        slide: $.fn.slideToggle,
    };
    const $toggler = $(TOGGLER);
    $toggler.each(function (index, el) {
        const $togglerElem = $(el);
        const obj = $togglerElem.data("togglerObj");
        const togglerClass =
            $togglerElem.data("togglerClass") || "js-toggler__active";
        const objClass =
            $togglerElem.data("togglerObjClass") || "js-toggler__active";
        const animation = $togglerElem.data("togglerAnimation");
        const speed =
            $togglerElem.data("togglerSpeed") || (animation ? 500 : 0);
        const $obj = $(obj).hide();
        const animationFunc = ANIMATIONS[animation] || $.fn.toggle;

        $togglerElem.click(function (e) {
            e.preventDefault();
            animationFunc.call($obj, speed);
            $togglerElem.toggleClass(togglerClass);
            $obj.toggleClass(objClass);
        });
    });
}
